import { render, staticRenderFns } from "./create-order.vue?vue&type=template&id=554ed3fa&scoped=true&"
import script from "./create-order.vue?vue&type=script&lang=ts&"
export * from "./create-order.vue?vue&type=script&lang=ts&"
import style0 from "./create-order.vue?vue&type=style&index=0&id=554ed3fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554ed3fa",
  null
  
)

component.options.__file = "create-order.vue"
export default component.exports